export default "__VITE_ASSET__DHKiw64W__"